import { call, put, takeEvery } from "redux-saga/effects";
import { types } from "../actions";
import { activateSensorEndPoint } from "../../configuration";
import api from "../../api/utils";

function* DeviceSaga() {
  yield takeEvery(types.ACTIVATE_SENSOR, workActivateSensors);
}

function* workActivateSensors({ sensors }) {
  const tobeActivatedSensors = sensors.filter(
    (sensor) => sensor.checkboxSelected && !sensor.checkboxDisabled
  );
  if (tobeActivatedSensors.length > 0) {
    const toBeActivateSensorDeviceId = tobeActivatedSensors[0].id;
    const tobeActivatedSensor = {
      accountname: sessionStorage.getItem("accountId"),
      resourceidentifier: { deviceid: toBeActivateSensorDeviceId },
    };
    try {
      const url = activateSensorEndPoint();
      yield api({ url, payload: tobeActivatedSensor, method: "POST" });
      yield put({
        type: types.ACTIVATE_SENSOR_SUCCESS,
        payload: toBeActivateSensorDeviceId,
      });
      yield put({
        type: types.SET_SHOW_SENSOR_ACTIVATE_MODAL,
        payload: {
          showSensorActivatedModal: true,
          activationStatusMessage:
            "Your requested sensor will be activated shortly.",
        },
      });
    } catch (err) {
      yield put({
        type: types.SET_SHOW_SENSOR_ACTIVATE_MODAL,
        payload: {
          showSensorActivatedModal: true,
          activationStatusMessage: err.message,
        },
      });
    }
  }
}
export default DeviceSaga;
